import logger from "@insite/client-framework/Logger";

export interface WidgetInfoParameter {
    model: string;
    lang: string;
}

export interface WidgetInfoFreqParameter {
    model: string;
    lang: string;
    type: number;
    fluide: string;
    applicationId: string;
    mid: boolean;
}

export interface WidgetInfoPerfParameter {
    model: string;
    type: number;
    fluide: string;
    frequency: string;
    mid: boolean;
    application: string;
}
export interface WidgetInfoPerfPrintParameter {
    selectedRefrigerants: any;
    selectedFrequencies: any;
}

export interface PerformanceWidgetInfo {
    globalModel: string;
    productType: number;
    applicationID: string;
    applicationUI: string;
    application: string;
    fluides: Fluide[];
    textes: string[];
    vMaj: number;
    vMin: number;
}

export interface Fluide {
    refrigerant: string;
    azeotrop: string;
    seq: number;
    def_Cond: string;
    tc_max_63mid: number;
    classif: string;
}

export interface PerformanceWidgetPerfInfo {
    regime: string;
    pfWatt: number;
    pfBtu: number;
    pfKcal: number;
    evapC: number;
    condC: number;
    evapF: number;
    condF: number;
}

export type PerformanceWidgetPerfs = PerformanceWidgetPerfInfo[];

export type PerformanceWidgetFreqs = string[];

export const LocalizationEnum = Object.freeze({
    APPLICATION: 0,
    CONDITION: 1,
    CAPACITY: 2,
    REFRIGERANT_CHOOSE: 3,
    REFRIGERANT_FIRST: 4,
    SELECT_BOTH: 5,
    LOADING: 6,
});

export async function getWidgetInfo(parameters: WidgetInfoParameter): Promise<PerformanceWidgetInfo> {
    const { model, lang } = parameters;
    const url = "https://tselect.tecumseh.com/Handler/WidgetInfos";
    const dataToSend = new URLSearchParams();
    dataToSend.append("model", model);
    dataToSend.append("lang", lang);

    const headers = new Headers({
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded",
    });

    const requestOptions = {
        method: "POST", // HTTP method
        headers, // Set the headers with 'Access-Control-Allow-Origin' and 'Content-Type'
        body: dataToSend.toString(), // Convert the data to URL-encoded string
    };

    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        return (await response.json()) as Promise<PerformanceWidgetInfo>;
    } catch (error) {
        logger.error("Error fetching widgetInfo:", error);
        return {
            error,
        } as unknown as Promise<PerformanceWidgetInfo>;
    }
}

export async function getWidgetFreqInfo(parameters: WidgetInfoFreqParameter): Promise<PerformanceWidgetFreqs> {
    const { model, type, fluide } = parameters;
    const url = "https://tselect.tecumseh.com/Handler/WidgetFreqs";
    const dataToSend = new URLSearchParams();
    dataToSend.append("model", model);
    dataToSend.append("type", `${type}`);
    dataToSend.append("fluide", fluide);

    const headers = new Headers({
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded",
    });

    const requestOptions = {
        method: "POST", // HTTP method
        headers, // Set the headers with 'Access-Control-Allow-Origin' and 'Content-Type'
        body: dataToSend.toString(), // Convert the data to URL-encoded string
    };

    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        return (await response.json()) as Promise<PerformanceWidgetFreqs>;
    } catch (error) {
        logger.error("Error fetching widgetInfo:", error);
        return {
            error,
        } as unknown as Promise<PerformanceWidgetFreqs>;
    }
}

export async function getWidgetPerfInfo(parameters: WidgetInfoPerfParameter): Promise<PerformanceWidgetPerfs> {
    const { model, type, application, fluide, frequency, mid } = parameters;
    const url = "https://tselect.tecumseh.com/Handler/WidgetPerfs";
    // const data = { model: "HGA2425ZXC", lang: "en", type: 1, fluide: "R404A", mid: false, freq: "50HZ", application: "LBP_Low_Back_Pressure" };

    const dataToSend = new URLSearchParams();
    dataToSend.append("model", model);
    dataToSend.append("type", `${type}`);
    dataToSend.append("fluide", fluide);
    dataToSend.append("mid", `${mid}`);
    dataToSend.append("freq", frequency);
    dataToSend.append("application", application);

    const headers = new Headers({
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded",
    });

    const requestOptions = {
        method: "POST", // HTTP method
        headers, // Set the headers with 'Access-Control-Allow-Origin' and 'Content-Type'
        body: dataToSend.toString(), // Convert the data to URL-encoded string
    };

    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`Failed to fetch data: ${response.statusText}`);
        }
        return (await response.json()) as Promise<PerformanceWidgetPerfs>;
    } catch (error) {
        logger.error("Error fetching widgetInfo:", error);
        return {
            error,
        } as unknown as Promise<PerformanceWidgetPerfs>;
    }
}
